import { getPlayerMatchStats, getPlayStats } from './matchStats';
import { getPlayerSeasonStats } from './seasonStats';

export const HIDDEN_SEASONS = ['2005-2006'];

export const getStatistics = (season, play) => {
  if (HIDDEN_SEASONS.includes(season)) {
    return {
      matchStatistics: null,
      seasonStatistics: null,
      statistics: null,
    };
  }
  return {
    matchStatistics: getPlayerMatchStats(play),
    seasonStatistics: getPlayerSeasonStats(
      play,
      play?.player?.seasonStats.find((stats) => stats.season === season),
    ),
    statistics: getPlayStats(play),
  };
};
